import React from 'react';
import { ArrowRight, Target, BookOpen, Users } from 'lucide-react';
import './IndianMarket.css';

interface StrategyData {
  title: string;
  description: string;
  icon: React.ReactNode;
  features: string[];
}

const IndianMarket: React.FC = () => {
  const strategies: StrategyData[] = [
    {
      title: 'Options Buying Strategies',
      description: 'Learn proven options buying strategies for NSE and BSE markets',
      icon: <Target className="strategy-icon" />,
      features: ['Call Options', 'Put Options', 'Straddle Strategies', 'Strangle Strategies']
    },
    {
      title: 'FNO Trading Education',
      description: 'Master Futures & Options trading with comprehensive learning modules',
      icon: <BookOpen className="strategy-icon" />,
      features: ['Futures Trading', 'Options Trading', 'Risk Management', 'Position Sizing']
    },
    {
      title: 'Community Learning',
      description: 'Join our community of successful FNO traders and learn from their experiences',
      icon: <Users className="strategy-icon" />,
      features: ['Strategy Discussions', 'Market Analysis', 'Peer Learning', 'Expert Guidance']
    }
  ];

  return (
    <section className="indian-market section" id="indian-market">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">India FNO Trading</h2>
          <p className="section-subtitle">
            Master Indian stock exchange Futures & Options trading with proven strategies
          </p>
        </div>

        <div className="strategies-grid">
          {strategies.map((strategy, index) => (
            <div key={strategy.title} className="strategy-card">
              <div className="strategy-header">
                <div className="strategy-icon-wrapper">
                  {strategy.icon}
                </div>
                <h3 className="strategy-title">{strategy.title}</h3>
              </div>
              <p className="strategy-description">{strategy.description}</p>
              <div className="strategy-features">
                {strategy.features.map((feature, idx) => (
                  <span key={idx} className="feature-tag">{feature}</span>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="market-cta">
          <div className="cta-content">
            <h3>Start Your FNO Trading Journey</h3>
            <p>Learn proven strategies for Indian stock exchange options and futures trading</p>
          </div>
          <div className="cta-actions">
            <a href="#platform" className="btn btn-primary">
              Join Community
              <ArrowRight className="btn-icon" />
            </a>
            <a href="#platform" className="btn btn-outline">
              Learn More
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndianMarket;
